module.exports = __webpack_public_path__ + "static/media/insu-henner.15ab98db.jpg";